<template lang="html">
  <section class="clients">
    <h1 class="title"><span>Clients</span></h1>
    <ul class="clients__list">
      <ClientItem v-for="(client, index) in clients" :key="index" :client="client.client" :image="client.image" :quote="client.quote" :author="client.author" :job="client.job"/>
    </ul>
  </section>
</template>

<script>
import anime from 'animejs';
import ClientItem from '../components/ClientItem.vue';

export default {
  name: 'Clients',
  components: {
    ClientItem
  },
  updated() {
    anime({
      targets: '.clientItem',
      opacity: [0,1],
      translateY: ["20px", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function(el, i) {
        return 300 * i + 1500;
      }
    });
  },
  computed: {
    clients() {
      return this.$store.state.clients;
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.clients {
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  &__list {
    margin: 100px auto 0;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 40px;
    grid-column-gap: 60px;
  }
  @include mq(0, 1024px) {
    &__list {
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }
  @include mq(0, 768px) {
    &__list {
      margin-top: 40px;
      grid-template-columns: repeat(3, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }
  @include mq(0, 512px) {
    &__list {
      grid-template-columns: repeat(1, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Clients.vue